import type { ImageItem } from '../types';

import { logger } from '../services/logger';

SectionSvgUpload.$inject = ['$resource'];

type FetchImageMethods =
  | 'getNaviSvgPreview'
  | 'getNaviFinal'
  | 'getNaviSvgFinal';

type ImageResourceMethod = (
  params: {
    id: string | number;
  },
  success?: (resp: ImageItem[]) => any,
  error?: (error: any) => any,
) => angular.resource.IResourceArray<ImageItem>;

export interface SectionSvgUploadResource {
  approveImages: (
    params: {
      id: string | number;
    },

    /**
     * Without this arg angular will handle params as request data
     */
    data: {},
  ) => angular.resource.IResourceArray<void>;
  getNaviSvgPreview: ImageResourceMethod;
  getNaviSvgFinal: ImageResourceMethod;
  getNaviPreview: ImageResourceMethod;
  getNaviSource: ImageResourceMethod;
  getNaviFinal: ImageResourceMethod;
  fetchImages(params: {
    sectionId: string | number;
    finalOnly?: boolean;
  }): Promise<{
    previewSvg: string | null;
    finalImage: string | null;
    finalSvg: string | null;
  }>;
}

export function SectionSvgUpload(
  $resource: angular.resource.IResourceService,
): SectionSvgUploadResource {
  const api: SectionSvgUploadResource = $resource(
    '',
    {},
    {
      approveImages: {
        method: 'POST',
        url: '/api/section/:id/imagesApprove',
      },
      getNaviSvgPreview: {
        method: 'GET',
        url: '/api/section/:id/svg/preview',
        isArray: true,
      },
      getNaviSvgFinal: {
        method: 'GET',
        url: '/api/section/:id/svg/final',
        isArray: true,
      },
      getNaviSource: {
        method: 'GET',
        url: '/api/section/:id/image/source',
        isArray: true,
      },
      getNaviPreview: {
        method: 'GET',
        url: '/api/section/:id/image/preview',
        isArray: true,
      },
      getNaviFinal: {
        method: 'GET',
        url: '/api/section/:id/image/final',
        isArray: true,
      },
    },
  ) as any;

  const fetchImage = async (
    sectionId: string | number,
    method: FetchImageMethods,
  ): Promise<string | null> =>
    api[method]({
      id: sectionId,
    }).$promise.then(
      (resp) => {
        if (!resp.length) {
          return null;
        }

        return resp[resp.length - 1].url.replace(/^http:/, 'https:');
      },
      (error) => {
        logger.error('Error fetching image', {
          error,
          sectionId,
          method,
        });

        return null;
      },
    );

  api.fetchImages = async ({ sectionId, finalOnly = true }) => {
    const [previewSvg, finalImage, finalSvg] = await Promise.all([
      finalOnly ? null : fetchImage(sectionId, 'getNaviSvgPreview'),
      fetchImage(sectionId, 'getNaviFinal'),
      fetchImage(sectionId, 'getNaviSvgFinal'),
    ]);

    return { previewSvg, finalImage, finalSvg };
  };

  return api;
}
